import { JobPositionRoleFilterItemFragment } from "@/gql/graphql"
import { useEffect } from "react"
import { create } from "zustand"

interface ProductionRolesStore {
  productionRoles: (JobPositionRoleFilterItemFragment | null)[]
  setProductionRoles: (productionRoles: (JobPositionRoleFilterItemFragment | null)[]) => void
}

const useProductionRolesStore = create<ProductionRolesStore>(set => ({
  productionRoles: [],
  setProductionRoles: productionRoles => set({ productionRoles }),
}))

/* Production roles include support roles in addition to normal roles */
export const useProductionRolesFilter = () => {
  const { productionRoles, setProductionRoles } = useProductionRolesStore()

  useEffect(() => {
    const fetchProductionRoles = async () => {
      const res = await fetch(`/api/filters/production-roles`)
      const data: { allProductionRoles: (JobPositionRoleFilterItemFragment | null)[] } = await res?.json()
      if (data?.allProductionRoles) {
        setProductionRoles(data?.allProductionRoles)
      }
    }

    fetchProductionRoles()
  }, [])

  return productionRoles
}
